import { useLang } from '@/context/LangContext';

const PHOTO = "https://customer-assets.emergentagent.com/job_lang-assist-2/artifacts/jdfld03k_ChatGPT%20Image%2024%20Nis%202026%2015_53_14.png";

const About = () => {
  const { t } = useLang();
  return (
    <div className="min-h-screen bg-white pt-24">
      <section className="py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
            <div className="rounded-2xl overflow-hidden border-2 border-[#C19B76]/20">
              <img src={PHOTO} alt="Nihal Yayla" className="w-full h-auto object-cover" data-testid="about-photo" />
            </div>
            <div>
              <p className="text-xs uppercase tracking-[0.25em] font-medium text-[#C19B76] mb-4">{t.story.overline}</p>
              <h1 className="text-5xl sm:text-6xl font-light tracking-tight text-[#0A0A0A] mb-8">{t.story.title}</h1>
              <div className="space-y-4">
                <p className="text-base font-light leading-relaxed text-[#555]">{t.story.p1}</p>
                <p className="text-base font-light leading-relaxed text-[#555]">{t.story.p2}</p>
                <p className="text-base font-light leading-relaxed text-[#555]">{t.story.p3}</p>
                <p className="text-base font-light leading-relaxed text-[#555]">{t.story.p4}</p>
              </div>
              <div className="border-l-2 border-[#C19B76] pl-4 mt-8">
                <p className="text-lg font-medium text-[#0A0A0A]">Nihal Yayla</p>
                <p className="text-sm text-[#999]">Director, AUREM8 LTD</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
